// components/payments/EmptyState.tsx
import React from "react";
import { FileText, Wallet, Search } from "lucide-react";

interface EmptyStateProps {
  type: "transactions" | "payouts";
  hasFilters?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({ type, hasFilters }) => {
  const config = {
    transactions: {
      icon: FileText,
      title: "No Transactions Found",
      description: hasFilters
        ? "No transactions match your current filters. Try adjusting your search or filter criteria."
        : "You haven't completed any tasks yet. Start working on available tasks to see your transactions here.",
      actionLabel: "Browse Available Tasks",
      actionLink: "/available-tasks",
      gradient: "from-[#8B52FF] to-[#E05A6A]",
    },
    payouts: {
      icon: Wallet,
      title: "No Payouts Found",
      description: hasFilters
        ? "No payouts match your current filters. Try adjusting your search or filter criteria."
        : "You haven't made any withdrawals yet. Once you have available earnings, you can request a payout.",
      actionLabel: "View Available Balance",
      actionLink: "/payments",
      gradient: "from-emerald-500 to-teal-500",
    },
  };

  const { icon: Icon, title, description, gradient } = config[type];

  return (
    <div className="py-16 px-6">
      <div className="max-w-sm mx-auto text-center">
        {/* Icon */}
        <div
          className={`w-20 h-20 mx-auto rounded-2xl bg-gradient-to-br ${gradient} flex items-center justify-center shadow-lg mb-6`}
        >
          {hasFilters ? (
            <Search className="w-10 h-10 text-white" />
          ) : (
            <Icon className="w-10 h-10 text-white" />
          )}
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-gray-900 mb-2">{title}</h3>

        {/* Description */}
        <p className="text-gray-500 leading-relaxed mb-8">{description}</p>

        {/* Actions */}
        {/* <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          {hasFilters ? (
            <button
              onClick={onClearFilters}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-[#8B52FF] to-[#E05A6A] text-white font-semibold rounded-xl shadow-lg shadow-purple-500/25 hover:shadow-xl hover:shadow-purple-500/30 hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200"
            >
              Clear All Filters
            </button>
          ) : (
            <Link
              to={actionLink}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-[#8B52FF] to-[#E05A6A] text-white font-semibold rounded-xl shadow-lg shadow-purple-500/25 hover:shadow-xl hover:shadow-purple-500/30 hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200 group"
            >
              {actionLabel}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
            </Link>
          )}
        </div> */}
      </div>
    </div>
  );
};

export default EmptyState;
